/* Product Slider 2026 — full-bleed centered Swiper carousel (Swiper 11
   bundle loaded globally from theme.liquid, same as pdp-main-2026), scoped
   per section instance so multiple instances don't clash.
   Card width and gutter live in CSS (--ps26-card-w / --ps26-gap with
   slidesPerView: 'auto'); gapPx() must mirror --ps26-gap because Swiper
   needs the gutter as spaceBetween for its centering math (it's re-synced on
   resize). The desktop "4 whole cards + symmetric edge bleed" phase from
   Figma comes from the CSS (the swiper box is widened one step and shifted
   left); mobile keeps Swiper's natural centered card with neighbours
   peeking.
   The carousel minimum depends on the breakpoint: desktop needs
   MIN_SLIDER_DESKTOP (5) cards to fill the row (4 visible + edge bleed),
   while mobile (≤768px, a single visible card) only needs
   MIN_SLIDER_MOBILE (2). Below the minimum the section stays static and CSS
   centers the cards (.product-slider-2026--static). The mode re-syncs on
   viewport resize and on shopify:section:load so the theme editor picks up
   added/removed blocks. */
(function () {
  var MOBILE_BREAKPOINT = 768; /* must match the CSS media query */
  var MIN_SLIDER_DESKTOP = 5;
  var MIN_SLIDER_MOBILE = 2;
  /* Swiper's loop mode has no clone system (it reorders the real slides),
     so it needs comfortably more slides than are ever visible at once
     (~5 on desktop, ~7 on very wide screens). Below this total the real set
     is duplicated; dots stay one per real card via realIndex % count. */
  var TOTAL_MIN_LOOP = 12;

  function minSliderCount() {
    return window.innerWidth <= MOBILE_BREAKPOINT ? MIN_SLIDER_MOBILE : MIN_SLIDER_DESKTOP;
  }

  /* Must mirror --ps26-gap in product-slider-2026.css. */
  function gapPx() {
    var w = window.innerWidth;
    if (w <= MOBILE_BREAKPOINT) return 17;
    if (w <= 1023) return 24;
    return (32 / 1440) * Math.min(w, 1920);
  }

  function destroySlider(root) {
    if (root.__ps26Nav) {
      root.__ps26Nav.remove();
      root.__ps26Nav = null;
    }
    if (!root.__ps26Slider) return;
    root.__ps26Slider.destroy(true, true);
    root.__ps26Slider = null;

    /* Loop mode reorders the slide elements in the DOM: drop our duplicates
       and restore the server-rendered order for the static layout. */
    var wrapper = root.querySelector('.swiper-wrapper');
    if (wrapper && root.__ps26Slides) {
      wrapper.querySelectorAll('[data-ps26-clone]').forEach(function (clone) {
        clone.remove();
      });
      root.__ps26Slides.forEach(function (slide) {
        wrapper.appendChild(slide);
      });
    }
  }

  function buildSlider(root, container, slideCount) {
    var wrapper = container.querySelector('.swiper-wrapper');
    if (!root.__ps26Slides) {
      root.__ps26Slides = Array.prototype.slice.call(wrapper.children);
    }

    var sets = slideCount >= TOTAL_MIN_LOOP ? 1 : Math.ceil(TOTAL_MIN_LOOP / slideCount);
    for (var c = 1; c < sets; c++) {
      root.__ps26Slides.forEach(function (original) {
        var clone = original.cloneNode(true);
        clone.setAttribute('data-ps26-clone', '');
        clone.removeAttribute('data-shopify-editor-block');
        wrapper.appendChild(clone);
      });
    }

    /* Arrows are opt-in (schema "show_arrows"): the container only renders
       when enabled. */
    var controlsEl = root.querySelector('.product-slider-2026__controls');

    var options = {
      slidesPerView: 'auto',
      centeredSlides: true,
      /* The gutter lives here instead of CSS margins so Swiper's centering
         math stays exact. */
      spaceBetween: gapPx(),
      speed: 400,
      loop: true,
      grabCursor: true
    };

    if (controlsEl) {
      options.navigation = {
        prevEl: controlsEl.querySelector('.product-slider-2026__arrow--prev'),
        nextEl: controlsEl.querySelector('.product-slider-2026__arrow--next')
      };
    }

    var slider = new Swiper(container, options);
    root.__ps26Slider = slider;

    /* Custom dots, same pattern as pdp-recipes-2026: one dot per real card
       even when the set was duplicated for loop mode. */
    var dotsContainer = root.querySelector('.product-slider-2026__dots');
    if (!dotsContainer || dotsContainer.getAttribute('data-show-nav') !== 'true') return;

    var navContainer = document.createElement('div');
    navContainer.className = 'custom-nav';

    for (var i = 0; i < slideCount; i++) {
      var button = document.createElement('button');
      button.setAttribute('data-nav', i);
      button.setAttribute('aria-label', 'Slide ' + (i + 1));
      button.type = 'button';
      if (i === 0) button.classList.add('is-active');
      navContainer.appendChild(button);
    }

    dotsContainer.appendChild(navContainer);
    root.__ps26Nav = navContainer;

    slider.on('realIndexChange', function (s) {
      var realIndex = s.realIndex % slideCount;
      navContainer.querySelectorAll('button').forEach(function (btn, idx) {
        btn.classList.toggle('is-active', idx === realIndex);
      });
    });

    navContainer.addEventListener('click', function (e) {
      if (e.target.tagName !== 'BUTTON') return;
      var idx = parseInt(e.target.getAttribute('data-nav'), 10);
      /* With duplicated sets the same card exists at idx, idx + count, …:
         go to the copy closest to the current position. */
      var total = slider.slides.length;
      var current = slider.realIndex;
      var target = idx;
      for (var candidate = idx; candidate < total; candidate += slideCount) {
        if (Math.abs(candidate - current) < Math.abs(target - current)) target = candidate;
      }
      slider.slideToLoop(target);
    });
  }

  function syncMode(root) {
    var container = root.querySelector('.product-slider-2026__slider');
    var wrapper = container && container.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var count = parseInt(root.getAttribute('data-real-count'), 10) ||
      (root.__ps26Slides ? root.__ps26Slides.length : wrapper.children.length);
    if (!count) return;

    var shouldSlide = count >= minSliderCount() && typeof Swiper !== 'undefined';

    if (!shouldSlide && root.__ps26Slider) destroySlider(root);
    root.classList.toggle('product-slider-2026--static', !shouldSlide);
    if (!shouldSlide) return;

    if (root.__ps26Slider) {
      /* Keep the gutter in sync with the fluid CSS scale. */
      root.__ps26Slider.params.spaceBetween = gapPx();
      root.__ps26Slider.update();
    } else {
      buildSlider(root, container, count);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-slider-2026]').forEach(syncMode);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  /* Crossing the mobile/desktop breakpoint changes the required minimum and
     the gutter, so re-sync after the viewport settles. */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initAll();
    }, 150);
  });

  /* Theme editor: re-init when the section is re-rendered (block added,
     removed or a setting changed). */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
